import { useNavigate } from 'react-router-dom';
import { LabsOrderHeader } from './labs-order-header';
import { ROUTE_LABS } from '../../../../constants/routes';
import '../../dashboard/dashboard-reset.css';

interface LabsOrderStepLayoutProps {
  currentStep: 1 | 2 | 3 | 4 | 5;
  children: React.ReactNode;
  showBackButton?: boolean;
  onBack?: () => void;
  onClose?: () => void;
}

export function LabsOrderStepLayout({
  currentStep,
  children,
  showBackButton = true,
  onBack,
  onClose,
}: LabsOrderStepLayoutProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate(ROUTE_LABS);
    }
  };

  return (
    <div className="dashboard-reset w-full">
      <div className="container mx-auto px-4 py-8">
        <div className="mx-auto max-w-4xl mb-8">
          <LabsOrderHeader
            currentStep={currentStep}
            onBack={handleBack}
            onClose={handleClose}
            showBackButton={showBackButton}
          />
        </div>

        <div className="mx-auto max-w-2xl">
          {children}
        </div>
      </div>
    </div>
  );
}
